import svg4everybody from "svg4everybody";
import $ from "jquery";
import Swiper from "swiper";
import fancybox from "fancybox";

// import languageSwitcher from './language-switcher';

fancybox($);

$(() => {
	function zoomPage() {
		$(window).resize(function() {
			calculateNewScale();
		});

		calculateNewScale(); // if the user go to the page and his window is less than 1600px

		function calculateNewScale() {
			let pageScale = $(window).width() / 1600;
			if (pageScale < 1 && pageScale > 0.5) {
				$("html").css({
					"zoom": pageScale
				});
			}
		}
	}

	function updatePagination(slider) {
		$(slider.container);
		if (
			$(slider.container)
				.find(".slider-pagination")
				.size()
		) {
			$(slider.container)
				.find(".slider-pagination__item")
				.removeClass("slider-pagination__item--active");
			$(slider.container)
				.find(".slider-pagination__item:eq(" + slider.realIndex + ")")
				.addClass("slider-pagination__item--active");
		}
	}

	function updateDescription(slider) {
		if ($(".slide__desc-wrap").size()) {
			$(".slide__desc-wrap").hide();
			$(".slide__desc-wrap:eq(" + slider.realIndex + ")").show();
		}
	}

	function initSlider(sliderElement, sliderId) {
		const $slider = $(sliderElement).find(".slider__container")[0];
		const $photolist = $('.photo-list[data-slider-id="' + sliderId + '"]');
		const slider = new Swiper($slider, {
			// Optional parameters
			direction: "horizontal",
			loop: true,
			keyboardControl: true,
			mousewheelControl: false,
			effect: "fade",
			fade: {
				crossFade: true
			},
			speed: 600,
			// autoHeight: true,
			// zoom: true,

			// onInit: function() {
			//
			// }
			onSlideChangeEnd(swiper) {
				updatePagination(swiper);
				updateDescription(swiper);
			}

			// If we need pagination
			// pagination: '.swiper-pagination',

			// Navigation arrows
			// nextButton: '.slider__arrow--next',
			// prevButton: '.slider__arrow--prev'

			// And if we need scrollbar
			// scrollbar: '.swiper-scrollbar',

			// wrapperClass: 'slider__slides',
			// slideClass: 'slider__slide'
		});

		$(sliderElement).on("click", ".slider__arrow--next", function(e) {
			e.preventDefault();
			// debugger;
			console.log(1);
			slider.slideNext();

			// if (slider.isEnd) {
			// 	// let sliderActiveId = $('.sliders__item.sliders__item--active').data('sliderId');
			// 	// let $sliderLink = $('top-nav__link[href="#' + sliderActiveId + '"]');
			// 	// debugger;
			// 	let $sliderLink = $('.top-nav__link:not(.top-nav__link--active)');
			// 	$sliderLink.trigger('click');
			// }
		});

		$(sliderElement).on("click", ".slider__arrow--prev", function(e) {
			e.preventDefault();
			slider.slidePrev();
		});

		$(sliderElement).on(
			"click",
			".slider__btn-open-photos-list",
			function() {
				document.getElementById("artwork-photos-list").style.height =
					"100%";
				document.getElementById("artwork-photos-list").className +=
					" overlay--opened";
			}
		);

		$photolist.on("click", ".photo-list__item-photoset", function() {
			const $selectedItem = $(this);
			document.getElementById("artwork-photos-list").style.height = "0%";
			slider.slideTo($selectedItem.index() + 1);
		});

		$("body .slider--projects").on("click", ".slide__content", function() {
			const $slideContent = $(this);
			const $slide = $slideContent.closest(".slide");
			const $url = $slide.data("url");
			window.open($url, "_self");
		});

		$(sliderElement).on("click", ".slider-pagination__item", function() {
			const $selectedItem = $(this);
			const index = Number($selectedItem.data("index")) + 1;
			console.log(index);
			slider.slideTo(index);
		});
	}

	function initFancybox() {
		$(".img-fancybox").fancybox({
			// title
			helpers: {
				title: {
					type: "inside"
				}
			},
			wrapCSS: "fancybox--detail-photo",
			padding: 0,

			// beforeShow() {
			// 	this.title = $(this.element).data('title');
			// },
			afterClose() {
				// console.log(2);
				// $(this.href).show();
				// $('.img-fancybox').css('display', 'block');
			}
		});
	}

	function initSliders() {
		console.log(11);
		function initSlidersItems(vm) {
			const promise = new Promise(function(resolve) {
				$(vm.sliderClass).each(function() {
					const sliderElement = this;
					const $slider = $(this);
					const sliderId = $slider.data("sliderId");

					initSlider(sliderElement, sliderId);
				});

				resolve();
			});

			return promise;
		}

		function closeFullList() {
			return new Promise(function(resolve) {
				$("body").on(
					"click",
					"#slider__btn-close-photos-list",
					function() {
						document.getElementById(
							"artwork-photos-list"
						).className = document
							.getElementById("artwork-photos-list")
							.className.replace(/\s?\boverlay--opened\b\s?/, "");
						setTimeout(function() {
							document.getElementById(
								"artwork-photos-list"
							).style.height = "0%";
						}, 500);
					}
				);
				resolve();
			});
		}

		function switchSliderInstance(vm) {
			return new Promise(function(resolve) {
				$("body")
					.find(".top-nav")
					.on("click", ".top-nav__link", function() {
						function getActiveSlider(vm0) {
							return $(
								vm0.sliderClass +
									'[data-slider-id="' +
									vm0.state.activeSlider +
									'"]'
							);
						}

						function getfullListActive(vm0) {
							return $(
								vm0.fullListClass +
									'[data-slider-id="' +
									vm0.state.activeSlider +
									'"]'
							);
						}

						function getActiveSliderId($link) {
							return $link.attr("href").slice(1);
						}

						function rerenderSliderSwitcher() {
							$(".top-nav__link").removeClass(
								"top-nav__link--active"
							);
							$(
								'.top-nav__link[href="#' +
									vm.state.activeSlider +
									'"]'
							).addClass("top-nav__link--active");
						}

						function switchSliderInstance0(vm0) {
							const $slider = $(vm.sliderClass);
							const $sliderActive = getActiveSlider(vm0);

							$slider.addClass("sliders__item--inactive");
							$slider.removeClass("sliders__item--active");
							$sliderActive
								.removeClass("sliders__item--inactive")
								.addClass("sliders__item--active");
							$sliderActive
								.find(".slider__container")[0]
								.swiper.update();
						}

						function switchSliderInstance0FullList(vm0) {
							const $fullList = $(".overlay__photo-list");
							const $fullListActive = getfullListActive(vm0);

							$fullList.addClass("overlay__photo-list--inactive");
							$fullList.removeClass(
								"overlay__photo-list--active"
							);
							$fullListActive
								.removeClass("overlay__photo-list--inactive")
								.addClass("overlay__photo-list--active");
						}

						function updateActiveSlider(vm0, $link) {
							vm0.state.activeSlider = getActiveSliderId($link);

							return vm0;
						}

						const $link = $(this);

						vm = updateActiveSlider(vm, $link);

						rerenderSliderSwitcher(vm);
						switchSliderInstance0(vm);
						switchSliderInstance0FullList(vm);
					});
				resolve();
			});
		}

		const vm = {
			sliderClass: ".slider",
			fullListClass: ".overlay__photo-list",
			state: {
				activeSlider: ""
			}
		};

		initSlidersItems(vm)
			.then(function() {
				closeFullList();
				switchSliderInstance(vm);
			})
			.catch(function() {
				console.log("some error");
			});
	}

	function initTooltips() {
		let attr = "hint";
		$(".hint").each(function(index, el) {
			$(el).remove();
		});
		$(`[data-${attr}]`).each(function(i, el) {
			console.log(attr, i, el);
			// debugger;
			let hintData = $(el).data(attr);
			let hint = document.createElement("div");
			hint.classList.add("hint");
			hint.innerHTML = hintData;

			let parentContainer = $(el).parents(".main__center")[0];
			let parentContainerBounding = parentContainer.getBoundingClientRect();
			let hintLeftPosition =
				parentContainerBounding.left + parentContainerBounding.width;

			let termBounding = el.getBoundingClientRect();
			let hintTopPosition = termBounding.top;

			// hint.style.left = `${hintLeftPosition}px`;
			$(hint).appendTo(el);
			let hintBounding = hint.getBoundingClientRect();
			hint.style.marginTop = `-${hintBounding.height / 2 + 10}px`;
		});
	}

	function initDict() {
		let $letters = $("#letters");
		if (!$letters.length) return;

		let vm = {
			defaultLetter: $($(".letters__letter")[0]).data("letter") || "а"
		};
		vm.activeLetter = getLetterFromHash();
		openDict();

		// $letters.on('.letters__letter', 'click', ).each(function(index, el){
		// 	if (index == 0) {
		// 		vm.activeLetter = $(el).attr('id');
		// 	}
		// })

		window.addEventListener("hashchange", onHashChange, false);

		function onHashChange() {
			vm.activeLetter = getLetterFromHash();
			openDict();
			// console.log(hash);
		}

		function getLetterFromHash() {
			return decodeURI(window.location.hash.slice(1) || vm.defaultLetter);
		}

		function openDict() {
			// debugger;
			resetDict();
			$(`[data-letter=${vm.activeLetter}]`).addClass(
				"letters__letter--active"
			);
			$(`#${vm.activeLetter}`).addClass("dicts__dict--active");
			initTooltips();
		}

		function resetDict() {
			$(".letters__letter").removeClass("letters__letter--active");
			$(".dicts__dict").removeClass("dicts__dict--active");
		}
	}

	svg4everybody();

	initSliders();

	// initSlider();

	initFancybox();

	// languageSwitcher();

	initDict();

	zoomPage();
});



// WEBPACK FOOTER //
// ./app/scripts/app.js